import { atom } from "recoil";

interface CompanyType {
    id: number;
    name: string;
    hq: string;
    company_size: number;
    website: string;
    no_of_users: number;
    description: string;
}
interface Company {
    company_id: number;
    company_name: string;
}
interface Role {
    id: number;
    name: string;
    description: string;
}
interface Country {
    id: number;
    code: string;
    name: string;
    description: string;
}
interface Language {
    id: number;
    code: string;
    name: string;
    is_active: boolean;
    description: string;
}
interface Currency {
    id: number;
    code: string;
    name: string;
    symbol: string;
    is_active: boolean;
    description: string | null;
}
interface Location {
    id: number;
    code: string;
    name: string;
    is_active: boolean;
    description: string | null;
}

interface mybusinesspresence {
    title: string;
    options: any[];

}

interface togglePreference {
    title: string;
    options: any[];

}

interface mapStylePreference {
    title: string;
    options: any[];

}

export interface SettingsData {
    company_types: CompanyType[];
    company: Company[];
    roles: Role[];
    countries: Country[];
    languages: Language[];
    currencies: Currency[];
    locations: Location[];
    user_groups?: any[];
    mapstyle: string;
    mybusinesspresence: mybusinesspresence;
    togglePreference: togglePreference;
    mapStylePreference: mapStylePreference;
    subLevelPreference: any[];
}
export interface UserSettings {
    language: string;
    currency: string;
    location: string;
    email_notification: boolean;
    toggle_defaults: {
        spotlight: boolean;
        eHPopulation: boolean;
        pointsOfInterest: boolean;
        myBusinessPresence: boolean,
        coreTransactionalValue: boolean
    };
    mapstyle_defaults: string;
    mbp_defaults: {
        "Relationship Manager": {
            ptype: boolean;
            active: boolean;
            growth: boolean;
            closed: boolean;
            performance: boolean;
        },
        Branch: {
            ptype: boolean;
            active: boolean;
            growth: boolean;
            closed: boolean;
            performance: boolean;
        },
        Partner: {
            ptype: boolean;
            active: boolean;
            growth: boolean;
            closed: boolean;
            performance: boolean;
        }
    };
    sublevel_defaults:string;
}

export interface currenciesType {
    id: number,
    code: string,
    name: string,
    symbol: string,
    is_active: boolean,
    description: string
}

export const AllSettingsState = atom({
    key: 'allSettings',
    default: {} as SettingsData,
});

export const UserSettingsState = atom({
    key: 'userSettings',
    default: {} as UserSettings,
});

export const currencies = atom({
    key: 'currencies',
    default: [] as currenciesType[],
});
